module.exports = __webpack_public_path__ + "assets/HKNova-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Light.ttf
// module id = 140
// module chunks = 0